import  React, { memo, VFC } from 'react';
import {
  Center,Spinner,
  Heading,Box,Flex,
  Table,Tbody,Tr,Th,Td,
} from '@chakra-ui/react';
import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { caseDetailObj } from '../../../types/issue';
import { GV_DESKS } from '../../../hooks/useConst';
import { MultiXSText } from '../../atoms/text/MyText';

type Props = {
  caseDetailObj: caseDetailObj|null;
  executing: boolean;
};

export const CaseDetailBase: VFC<Props> = memo((props) => {
  const { caseDetailObj, executing } = props;
  const { loginUser } = useLoginUser();
  // const [ account, setAccount ] = useState('');
  // const [ opelog, setOpelog ] = useState(false);
  
  return (
    <Center>
      <Box
        w="95%"
        bg="white"
        borderRadius="10px"
        shadow="md"
        margin="10px"
      >
        <Flex m="10px">
          <Heading size="md" margin="5px">
            <Flex>■問い合わせ詳細画面</Flex>
          </Heading> 
        </Flex>
        
        {executing || caseDetailObj === null ? (
          <Center h="80vh">
            <Spinner color="teal.500" />
          </Center>
          
        ) : (
          <Box mt="5px">
            {/* 以下CASEリスト */}
            <Table
              id="table-detail-case-one"
              mb="0px"
              border="1"
              variant="striped"
              colorScheme="gray"
              size="sm"
            >
              <Tbody>
                <Tr>
                  <Th background="#aaaaaa" color="white" width="180px">管理番号</Th>
                  <Td>{caseDetailObj.manage_id2}</Td>
                  {GV_DESKS.includes(loginUser.userGroup) && (
                    <>
                      <Th background="#aaaaaa" color="white" width="180px">ケース履歴番号</Th>
                    <Td>{caseDetailObj.case_history_no}</Td>
                    </>
                  )}
                </Tr>
                <Tr>
                  <Th background="#aaaaaa" color="white">NECCIインシデントID</Th>
                  <Td>{caseDetailObj.necci_incident_id}</Td>
                  {GV_DESKS.includes(loginUser.userGroup) && (
                    <>
                      <Th background="#aaaaaa" color="white">NESインシデントID</Th>
                      <Td>{caseDetailObj.nes_incident_id}</Td>
                    </>
                  )}
                </Tr>
                <Tr>
                  <Th background="#aaaaaa" color="white">作成日</Th>
                  <Td>{caseDetailObj.create_date}</Td>
                  {GV_DESKS.includes(loginUser.userGroup) && (
                    <>
                      <Th background="#aaaaaa" color="white">最終更新日</Th>
                      <Td>{caseDetailObj.last_modified_date}</Td>
                    </>
                  )}
                </Tr>
                {GV_DESKS.includes(loginUser.userGroup) && (
                  <>
                    <Tr>
                      <Th background="#aaaaaa" color="white">状況</Th>
                      <Td>{caseDetailObj.main_status}</Td>
                      <Th background="#aaaaaa" color="white">サブ状況</Th>
                      <Td>{caseDetailObj.sub_status}</Td>
                    </Tr>
                    <Tr>
                      <Th background="#aaaaaa" color="white">緊急度</Th>
                      <Td>{caseDetailObj.urgency}</Td>
                      <Th background="#aaaaaa" color="white">優先指定</Th>
                      <Td>{caseDetailObj.priority_assign}</Td>
                    </Tr>
                  </>
                )}
                <Tr>
                  <Th background="#aaaaaa" color="white">種別／子種別</Th>
                  <Td colSpan={3}>{caseDetailObj.type1}／{caseDetailObj.type2}</Td>
                </Tr>
                <Tr>
                  <Th background="#aaaaaa" color="white">アカウントID</Th>
                  <Td>{caseDetailObj.linked_account_id}</Td>
                  {GV_DESKS.includes(loginUser.userGroup) && (
                    <>
                      <Th background="#aaaaaa" color="white">PayerアカウントID</Th>
                      <Td>{caseDetailObj.payer_account_id}</Td>
                    </>
                  )}
                </Tr>
                <Tr>
                  <Th background="#aaaaaa" color="white">お客様名</Th>
                  <Td colSpan={3}>{caseDetailObj.end_user}</Td>
                </Tr>
                <Tr>
                  <Th background="#aaaaaa" color="white">件名</Th>
                  <Td colSpan={3}><MultiXSText str={caseDetailObj.subject} /></Td>
                </Tr>
                <Tr>
                  <Th colSpan={4} background="#aaaaaa" color="white">説明</Th>
                </Tr>
                <Tr>
                  <Td colSpan={4}><MultiXSText str={caseDetailObj.description} /></Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>
        )}
      </Box>
    </Center>
  );
});